module.exports = __webpack_public_path__ + "img/back-arrow-gray.3bdb73a5.svg";